import * as angular from 'angular';
import { fn } from '@common/utils';
import { constants, SetMaxGridHeight, NavKendoRegister } from '@common/navkendo/kutils';
/**
* Panel that adapts its "idms_AdaptiveHeight" marked content to the remaining height
* ATTENTION: The content must be added initially.
* Dynamic content must trigger a resize to adapt initially!
*/
export class NavAdaptivePanel extends kendo.ui.Widget {
  /** Minimum adaptive height to be ensured for the adaptive content */
  private minAdaptiveHeight = 0;
  constructor(element: any, options: INavAdaptivePanelSetting) {
    super(element, options);
    // Enable container scroll
    if (!(options && options.NoScroll)) {
      this.element.css("overflow-y", "auto");
    }
    // Apply settings
    if (options && options.MinHeight >= 0) {
      this.minAdaptiveHeight = options.MinHeight;
    }
    // Watch fixed containers (and self) for resize
    let adaptHeightDebounced = fn.debounce(() => this.AdaptHeight(), 25, this, false), fixedChildren = this.element.children().not("." + cssAdaptiveHeight);
    fixedChildren.add(this.element).onSizeChanged(adaptHeightDebounced);
    // Watch uninitialized kendo widgets to adapt size initially
    let scope = angular.element(this.element).scope();
    if (scope) {
      this.one(constants.NavDestroy, scope.$on("kendoWidgetCreated", (s: any, kendoWidget: kendo.ui.Widget) => {
        if (kendoWidget && kendoWidget.element && jQuery.contains(this.element[0], kendoWidget.element[0])) {
          adaptHeightDebounced();
          if (kendoWidget instanceof kendo.ui.Grid) {
            // Update on changed datasource to adapt changed height
            kendoWidget.bind("dataBound", adaptHeightDebounced);
          }
        }
      }));
    }
    else {
      console.error("WaitForWidget WOut Scope");
    }
    // Find closest parent window or container with fixed height and watch for resize
    this.element.parents().each((index, elem) => {
      var ovf = $(elem).css("overflow-y");
      if (ovf === "hidden") {
        let fixedParent = $(elem);
        // Listen (and auto reset) on resize on fixed container
        fixedParent.on("resize", adaptHeightDebounced);
        this.bind(constants.NavDestroy, () => fixedParent.off("resize", adaptHeightDebounced));
        var isWindow = fixedParent.hasClass("k-window-content");
        if (isWindow) {
          // Listen on (and autoreset) resize on kendo window (container will not react on enlarge after shrink otherwise),
          var kwindow = fixedParent.data("kendoWindow");
          if (kwindow) {
            kwindow.bind("resize", adaptHeightDebounced);
            this.one(constants.NavDestroy, () => kwindow.unbind("resize", adaptHeightDebounced));
          }
        }
        // Abort loop
        return false;
      }
    });
    // Adapt size initially
    adaptHeightDebounced();
  }
  /** Adapt marked content height to the remaining height */
  public AdaptHeight() {
    var adaptiveChildren = this.element.children("." + cssAdaptiveHeight);
    if (adaptiveChildren.length > 0) {
      // Max height
      var containerHeight = this.element.height();
      // Fixed height
      var fixedChildren = this.element.children().not("." + cssAdaptiveHeight);
      var fixedHeight = 0;
      var ignoredItemPositions = ["absolute", "fixed"];
      fixedChildren.each(function () {
        let currentElem = $(this);
        let isAbsolutePosition = ignoredItemPositions.indexOf(currentElem.css("position")) >= 0;
        // Only add heights of non-absolute positioned elements
        if (!isAbsolutePosition) {
          fixedHeight += currentElem.outerHeight(true);
        }
      });
      // Adaptive height
      var adaptiveHeight = containerHeight - fixedHeight;
      adaptiveChildren.css("min-height", this.minAdaptiveHeight + "px");
      var adaptiveMaxHeight = Math.max(adaptiveHeight / adaptiveChildren.length, this.minAdaptiveHeight);
      if (adaptiveMaxHeight > 0) {
        adaptiveChildren.css("max-height", adaptiveMaxHeight + "px");
      }
      else {
        // Max height = 0 might prevent widget rendering on delayed widgets (k-ng-delay), so don't allow this!
        // This might also result in content overflow on small panels
        adaptiveChildren.css("max-height", "none");
      }
      var me = this;
      // Adapt Kendo TabStrip inside adaptive panel
      adaptiveChildren.each((index, elem) => {
        // Find this element or any descendant with kendoTabStrip data
        var tabstrip = $(elem).find('*').addBack().filter(function () {
          return $(this).data('kendoTabStrip') !== undefined;
        }).first();
        var ktabstrip = <kendo.ui.TabStrip>tabstrip.data("kendoTabStrip");
        if (ktabstrip) {
          // Limit TabStrip height
          ktabstrip.element.css("max-height", adaptiveMaxHeight);
          // Limit kendo TabStrip panels height (will overflow otherwise)
          var tabStripHeader = ktabstrip.element.children(".k-tabstrip-items");
          var tabStripPanels = ktabstrip.element.children(".k-content");
          var maxTabStripPanelHeight = adaptiveMaxHeight - tabStripHeader.outerHeight(true);
          tabStripPanels.outerHeight(maxTabStripPanelHeight);
        }
      });
      // Adapt Kendo Grid inside adaptive panel
      adaptiveChildren.each((index, elem) => {
        // Find this element or any descendant with kendoGrid data
        var grid = $(elem).find('*').addBack().filter(function () {
          return $(this).data("kendoGrid") !== undefined;
        }).first();
        var kgrid = <kendo.ui.Grid>grid.data("kendoGrid");
        if (kgrid) {
          SetMaxGridHeight(kgrid, adaptiveMaxHeight);
        }
      });
    }
  }
  /** Destructor */
  destroy() {
    this.trigger(constants.NavDestroy);
    //DO NOT Remove from DOM !
    super.destroy();
  }
}
NavKendoRegister(<any>NavAdaptivePanel, "NavAdaptivePanel");

/** AdaptivePanel settings */
export interface INavAdaptivePanelSetting {
  /** Min height of the middle content in px */
  MinHeight?: number;

  /** Hide scrollbars in adaptive panel? */
  NoScroll?: boolean;
}

export const cssAdaptiveHeight = "idms_AdaptiveHeight";

declare global {
  interface JQuery {
    /** Custom 'Adaptive' Panel */
    data(key: "kendoNavAdaptivePanel"): NavAdaptivePanel;
  }
}
